import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListPersonActivityPathParameters } from 'api/actions/hr-list-person-activity/hr-list-person-activity-path-parameters';
import { HrListPersonActivityResponse } from 'api/actions/hr-list-person-activity/hr-list-person-activity-response';

type HrListPersonActivityQueryParameters = Record<string, any>;

/**
 * The path of the HrListPersonActivity action.
 */
export const hrListPersonActivityActionPath = new SweetPath<keyof HrListPersonActivityPathParameters>(
  '/api/hr/people/{personId}/activity',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrListPersonActivity actions.
 */
export default function createHrListPersonActivityAction(axios: AxiosInstance) {
  return function hrListPersonActivityAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrListPersonActivityPathParameters;
    query?: HrListPersonActivityQueryParameters;
  }) {
    const path = hrListPersonActivityActionPath.insert(parameters);

    return axios.request<HrListPersonActivityResponse, HrListPersonActivityResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
